import styled, { css } from "styled-components";
import * as Variables from "./Variables";
import checked_icon from "../assets/icons/checked.svg"

//containers

export const Disclaimer = styled.p`
  font-size: 1.3rem;
  opacity: .8;
`;


export const IconContainer = styled.div`
  svg{
    width: 22px;
    height: 22px;
  }
`;


export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  box-shadow: 0px -2px 20px #00000021;
  border-radius: 12px;
  min-height: 100vh;
  background-color: ${Variables.getColor().background} ;
  background: radial-gradient(300px 300px ellipse at left top, ${Variables.getColor().accent}10, transparent), radial-gradient(400px 400px ellipse at center bottom, ${Variables.getColor().secondary}15, transparent);
  background-attachment: fixed;
  background-size: 100% 100vh;
`;

export const LayoutContent = styled.div`
  padding: 0 12px;
  display: grid;
  gap: 16px;
  border-radius: 0px;
  width: 100%;
  margin-bottom: 80px;

  @media ${Variables.device.desktop}{
    grid-template-columns: 360px 1fr;
    gap: 32px;
    max-width: 1100px;
    margin: 0 auto;
    margin-bottom: 80px;
  }
`;

export const Separator = styled.hr`
  margin: 8px auto;
  width: 64px;
  height: 4px;
  background: ${Variables.getColor().secondary};
  border: none;
  border-radius: 14px;
  opacity: .3;
`;

export const DrawerContainer = styled.div`
  background: ${Variables.getColor().card};
  box-shadow: 0px -2px 20px ${Variables.getColor().shadowColor}40;
  border-radius: 16px;
  padding-bottom: 4px;
  margin-top: auto;
  width: 100%;
  max-height: 100%;
  overflow: auto;

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    backdrop-filter: blur(5px);
    background: ${Variables.getColor().card}e6;
    border: 1px solid ${Variables.getColor().textColor}33;
  }
`;

export const MainContainer = styled.div`
  background-color: ${Variables.getColor().background};
  box-shadow: 0px -2px 20px #00000021;
  border-radius: 12px;
`;

export const SubTitle = styled.h3`
    font-size: 1.4rem;
    opacity: 0.7;
    margin-bottom: 16px;

    @media ${Variables.device.tablet}{
      font-size: 1.8rem;
  }
`;

//parts

export const TitleCardContainer = styled.div`
  display: flex;
  padding: 20px 0;
  align-items: center;
  position: relative;

  svg {
    margin-right: 12px;
    path{
      fill:  ${Variables.getColor().textColor};
    }
  }

  h4 {
    font-size: 1.4rem;
  }
`;

//form components

export const InputField = styled.div`
  margin-bottom: 16px;

  label {
    color: ${Variables.getColor().textColor}70;
    font-size: 1.2rem;
    font-weight: 600;
    font-weight: 600;
    padding: 8px 0;
    display: block;

    span{
      color: red;
    }
  }

  input {
    background: ${Variables.getColor().chip};
    border: 2px solid transparent;
    border-radius: 8px;
    width: 100%;
    height: 46px;
    padding: 0 18px;
    color: ${Variables.getColor().textColor};
    
    &:focus{
      border: 2px solid ${Variables.getColor().accent};
    }

    &.bg{
      background-size: 20px;
    background-repeat: no-repeat;
    background-position: 16px;
    //padding-left: 50px;

    &.phone{
      //background-image: url("https://via.placeholder.com/30x30");
    }
    &.address{
      //background-image: url("https://via.placeholder.com/30x30");
    }
    }
  }
`;

export const RadioContainer = styled.div`
  background: ${Variables.getColor().chip};
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: 16px;
  display: grid;
  gap: 4px;
  padding: 4px 0;
`;

export const RadioContainerSide = styled(RadioContainer)`
    display: grid;
    grid-auto-columns: auto;
    grid-auto-flow: column;
    width: max-content;
`

export const RadioFieldset = styled.fieldset`
border: none;
`

export const RadioLegend = styled.legend`
    color: ${Variables.getColor().textColor}70;
    font-size: 1.2rem;
    font-weight: 600;
    font-weight: 600;
    padding: 8px 0;
    display: block;
`

export const RadioButton = styled.div<{ noIcon?: "true" | "false" }>`
  border-radius: 8px;
  height: 46px; 

  label {
    border-radius: 6px;
    padding: 0 8px;
    padding: ${(props) => props.noIcon === "true" && "0 12px"};
    font-size: 1.4rem;
    color: ${Variables.getColor().textColor};
    display: flex;
    align-items: center;
    height: 100%;
    transition: ease-in 0.1s;
    background-repeat: no-repeat;
    cursor: pointer;
    justify-content: ${(props) => props.noIcon === "true" && "center"};
    font-weight: 600;
    margin: 0 4px;

    &:before{
      content: "";
      display: ${(props) => props.noIcon === "true" && "none"};
      width: 22px;
      height: 22px;
      border: 2px solid ${Variables.getColor().textColor};
      margin: 0 10px;
      border-radius: 6px;
    }
  }

  input {
    display: none;
    &:checked + label {
      font-weight: 600;
      background-color: ${Variables.getColor().secondary};
      color: white !important;
      &:before{
        border-color: ${Variables.getColor().textColor};
        background: url(${checked_icon}) no-repeat;
        background-size: 12px 12px;
        background-position: center;
        background-image: ${(props) => props.noIcon === "true" && "none"};
      }
    }
  }
`;

//buttons

export const AddButton = styled.button`
  padding: 4px 7px 4px 7px;
  background: ${Variables.getColor().accent};
  box-shadow: 1px 1px 15px ${Variables.getColor().accent}60;
  color: #00000060;
  border-radius: 12px;
  display: flex;
  align-items: center;
  font-weight: 600;
  min-height: 40px;

  svg {
    width: 12px;
    height: 12px;
    margin: 0 7px;
    path {
      fill: white;
    }
  }
`;

export const IconButtonSecondary = styled.button`
  background: ${Variables.getColor().secondary}60;
  box-shadow: 1px 1px 15px ${Variables.getColor().secondary}20;
  color: #00000060;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${Variables.getColor().secondary};
    }
  }
`;

//bottom action bar

export const ActionBar = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 12px 0;
`;

export const ButtonStyles = css`

  padding: 4px 17px 4px 17px;
  background-color: grey;
  background: ${Variables.getColor().accent};
  box-shadow: 1px 1px 15px ${Variables.getColor().accent}60;
  color: white;
  border-radius: 12px;
  display: flex;
  font-weight: 600;
  justify-items: center;
  align-items: center;
  height: 48px;
  font-size: 1.4rem;

  svg {
    margin-right: 8px;
    
    path{
      fill: white;
    }
  }
  
  span {
    background-color: #FFFFFF30;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 8px;
    margin-left: 10px;
    justify-self: flex-end;
    margin-right: -12px;
  }

  &:disabled{
    opacity: .5;
  }
`;

export const AddButtonExtended = styled.button`
  ${ButtonStyles}
`;

export const IconButton = styled.button`
    width: 40px;
    height: 40px;
    background-color: ${Variables.getColor().textColor}50;
    position: absolute;
    border-radius: ${Variables.setRadius.buttons};;
    left: 16px;
    top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg{
      width: 15px;
      height: 15px;
      margin: 0;
      path{
        fill: white;
      }
    }

`;

export const CloseButton = styled(IconButton)`
  top:14px;
  right: 0;
  left: auto;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${Variables.getColor().chip};
  display: none;

  svg{
      width: 12px;
      height: 12px;
      margin: 0;
      path{
        fill: ${Variables.getColor().textColor}90;
      }
    }

  @media ${Variables.device.desktop}{
    display: block;
  }

`

export const BackButton = styled.button`
  background: ${Variables.getColor().chip};
  box-shadow: 1px 1px 15px ${Variables.getColor().chip}20;
  color: ${Variables.getColor().textColor};
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 17px;


  svg {
    margin-right: 8px;
    path{
      fill:    ${Variables.getColor().textColor};
    }
  }
`;

export const PrimaryButton = styled.button`
  padding: 4px 17px 4px 17px;
  background: ${Variables.getColor().accent};
  box-shadow: 1px 1px 15px ${Variables.getColor().accent}60;
  color: white;
  border-radius: 12px;
  display: flex;
  font-weight: 600;
  justify-items: center;
  align-items: center;
  height: 48px;

  svg {
    margin-right: 8px;
   path{
     fill: white;
   }
  }

  span {
    background-color: #FFFFFF30;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 8px;
    margin-left: 10px;
    justify-self: flex-end;
  }
`;

export const SecondaryButton = styled.button`
  background: ${Variables.getColor().chip};
  box-shadow: 1px 1px 15px ${Variables.getColor().chip}20;
  color: ${Variables.getColor().textColor};
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 17px;
  margin-right: 15px;

  svg {
    margin-right: 8px;
    path{
      fill: ${Variables.getColor().textColor};
    }
  }
`;

export const CartPreview = styled.div`
  background: ${Variables.getColor().chip};
  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 8px;

  .icon-cart {
    background: ${Variables.getColor().secondary};
    box-shadow: 2px 2px 15px ${Variables.getColor().secondary}60;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    svg {
      path{
        fill: white;
      } 
    }
  }

  h4 {
    font-size: 1.2em;
    font-weight: 600;
  }

  .cart-details {
    padding-left: 10px;
  }
  .cart-total {
    text-align: right;
    margin-left: auto;
  }
`;
export const ResumePreview = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  padding: 16px;
  border-top: 1px dashed ${Variables.getColor().textColor}50;

  h4 {
    font-size: 1.2em;
    font-weight: 600;
    color: ${Variables.getColor().textColor}70;
  }

  .cart-details {
  }
  .cart-total {
    text-align: right;
    margin-left: auto;
  }
`;